import React from 'react'
import { Field, ErrorMessage } from 'formik'
import { capitalizeFirstLetter } from 'utils/helpers'
import FieldError from './FieldError'
import { RadioButton, RadioButtonGroup } from 'components/Zui'

export const Radio = props => {
    return (
        <div className="input-wrapper-column">
            <div className="form-label">
                <span>{props.label || capitalizeFirstLetter(props.name)}</span>
            </div>
            <Field component={RadioComponent} {...props} />
            <ErrorMessage name={props.name} component={FieldError} />
        </div>
    )
}

const RadioComponent = ({ field, options, ...props }) => {
    const { onBlur, ...fieldProps } = field

    return (
        <RadioButtonGroup {...fieldProps} {...props}>
            {options.map(option => {
                if (typeof option === 'string') {
                    return (
                        <RadioButton
                            key={option}
                            name={field.name}
                            label={capitalizeFirstLetter(option)}
                            value={option.toLowerCase()}
                        ></RadioButton>
                    )
                } else if (typeof option === 'object') {
                    const { value, label } = option
                    return (
                        <RadioButton
                            key={value}
                            name={field.name}
                            label={capitalizeFirstLetter(label || value)}
                            value={value.toLowerCase()}
                        ></RadioButton>
                    )
                } else return null
            })}
        </RadioButtonGroup>
    )
}
